import React from 'react';
import { IGalleryStatus } from '../../global.d';
import { getGalleryStatus } from '../../utils/util';
import classNames from 'classnames';
import './StatusTag.scss';
import { getFontSize } from '../../utils/style';
import moment from 'moment';

export interface IStatusTag {
  status: IGalleryStatus;
  className?: string;
  style?: React.CSSProperties;
  fontSize?: number;
  invert?: boolean;
  startTime?: string;
  endTime?: string;
}
const StatusTag = function(props: IStatusTag) {
  let { status, startTime, endTime } = props;

  if (typeof startTime != 'undefined' && typeof endTime != 'undefined') {
    if (moment().isBefore(startTime)) {
      status = IGalleryStatus.wait;
    } else if (moment().isAfter(endTime)) {
      status = IGalleryStatus.end;
    } else if (moment().isBetween(startTime, endTime)) {
      status = IGalleryStatus.start;
    }
  }
  const [statusName, statusColor] = getGalleryStatus(status);
  const cns = classNames('status-tag', props.className);
  const { fontSize } = props;
  const oneStyle = props.invert
    ? {
        color: statusColor
      }
    : { backgroundColor: statusColor, ...props.style };
  Object.assign(oneStyle, getFontSize(fontSize));
  return (
    <span className={cns} style={oneStyle}>
      {statusName}
    </span>
  );
};

export default StatusTag;
